module.exports = __webpack_public_path__ + "img/ic_email_nor.4f9f896d.svg";